// extracted by mini-css-extract-plugin
module.exports = {"OrderFooter":"OrderCreatePage_OrderFooter__sA-3V","ButtonRow":"OrderCreatePage_ButtonRow__3PbXM","Modal":"OrderCreatePage_Modal__2Jh_O"};